import { AxiosInstance } from 'axios';
import { Params as _Params } from '../types';

export type Params = _Params;

export enum Statuses {
  ERROR = 'error',
  READY = 'ready',
  WAITING = 'waiting',
}
export interface IImage {
  url: string;
  original: string;
  little: string;
  big: string;
}
export interface ISpace {
  id: string;
  partner_name: string;
  group_name: string;
  address: string;
  name: string;
  area: string;
  max_persons: string;
  is_ovz: boolean;
  status: string;
  // TODO: та херня теперь строка
  object_type: string;
  image: IImage;
}

export interface IProviders {
  $api: AxiosInstance;
}

export type Spaces = Array<ISpace>;

export interface IState {
  status: Statuses;
  spaces: Spaces;
}





// WEBPACK FOOTER //
// ./src/pages/organizations/card/spaces/types.ts